<template>
<div class="findpassword" id="">  
  <XR-head titleText="绑定邮箱" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
  <mu-row gutter>
    <mu-col width="100" tablet="100" desktop="33">
      <mu-text-field label="邮箱" icon=":fa fa-envelope-o" labelFloat fullWidth :disabled="isTestMobile" v-model="bindInfo.email" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="70" tablet="75" desktop="33">
      <mu-text-field label="验证码" helpText="点击右侧按钮获取，3分钟内有效" icon=":fa fa-key" labelFloat fullWidth v-model="bindInfo.code" />
    </mu-col>
    <mu-col width="30" tablet="25" desktop="33">      
      <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="login-div">
      <mu-raised-button label="绑 定" class="demo-raised-button" primary fullWidth @click="submit()" />
    </mu-col>
  </mu-row>
  <mu-row gutter>
    <mu-col width="100" tablet="50" desktop="33" class="div3">
      <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
    </mu-col>
  </mu-row>
</div>
</div>
</template>
<script>

export default {
  data () {
    return {
      isTestMobile : false,
      bindInfo:{
        email :'',
        code:''
      },      
      smsBtnText:'验证码'
    }
  },
  mounted(){
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.bindInfo.email=res.Data.email
          ths.isTestMobile = res.Data.IsTestEmail
        }
      });      
    },
    submit: function () {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/BindEmail",
        JSON.stringify(this.bindInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.getMemberInfo()
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    getSmsCode: function(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/SendBindEmailCode",
        JSON.stringify(this.bindInfo)
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.smsBtnText = res.Data * 60;
          var interval = setInterval(function(){
            if(ths.smsBtnText >0){
              ths.smsBtnText--
            }else{
              ths.smsBtnText = '验证码'
              clearInterval(interval)
            }
          }, 1000)  
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
.findpassword{
  background: white;
}
.findpassword .login-form {
  padding: 10px 20px 20px 10px;
}
.findpassword .login-div {
  padding: 40px 0px 0 20px;
}
.findpassword .demo-raised-button {
  height: 50px;
}
.findpassword .div2 {
  padding: 20px 0 0 0;
}
.findpassword .demo-flat-button.right {
  float: right;
}
.findpassword .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.findpassword .findpassword .notice{
  font-size: 12px;
}
.findpassword .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/emailBind.vue